import { createAction, props } from '@ngrx/store';
import { ShowcaseLoadMorePayload, ShowcasePayload, ShowcasesResponse, ShowcasesTypes, } from '../models/showcases';

export const loadAllShowcases = createAction(
  '[Showcases] Load all showcases',
  props<ShowcasePayload>(),
);

export const loadAllShowcasesComplete = createAction(
  '[Showcases] Load all showcases complete',
  props<ShowcasesResponse>(),
);

export const loadAllShowcasesFailure = createAction(
  '[Showcases] Load all showcases failure',
  props<any>(),
);

export const loadSingleShowcase = createAction(
  '[Showcases] Load single showcase',
  props<ShowcasePayload>(),
);

export const loadSingleShowcaseComplete = createAction(
  '[Showcases] Load single showcase complete',
  props<{ data: any, showcase: ShowcasesTypes, identifier: string, isMultiple: boolean }>(),
);

export const loadSingleShowcaseFailure = createAction(
  '[Showcases] Load single showcase failure',
  props<any>(),
);

export const loadMoreSingleShowcase = createAction(
  '[Showcases] Load more single showcase',
  props<ShowcaseLoadMorePayload>(),
);

export const loadMoreSingleShowcaseComplete = createAction(
  '[Showcases] Load more single showcase complete',
  props<{ data: any, showcase: ShowcasesTypes, isMultiple: boolean }>(),
);

export const loadMoreSingleShowcaseFailure = createAction(
  '[Showcases] Load more single showcase failure',
  props<any>(),
);
